<template>
  <div class="card">
    <div class="modal-header">
      <h5 class="modal-title">Report Bug</h5>
    </div>
    <div class="modal-body">
      <div class="mb-3">
        <label for="bug-details" class="form-label">Details</label>
        <textarea
          id="bug-details"
          class="form-control"
          rows="5"
          v-model="post.details"
          placeholder="Please describe the bug you encountered..."
        ></textarea>
      </div>
      
      <div class="mb-3">
        <label class="form-label">Attach Screenshots (Optional - Up to 3)</label>
        <div id="kt_dropzonejs_bug_report" class="dropzone">
          <div class="dz-message needsclick">
            <i class="bi bi-cloud-upload fs-3x text-primary"></i>
            <div class="ms-4">
              <span class="fs-4 fw-semibold text-gray-700">Drop files here or click to upload</span>
              <span class="fs-6 text-gray-500 d-block">Maximum 2 MB per file - Images only (Up to 3 files)</span>
            </div>
          </div>
        </div>
      </div>

      <div class="alert alert-info d-flex align-items-center p-3">
        <i class="fa fa-info-circle me-2"></i>
        <div>
          <strong>Quick Tip:</strong> You can also send a quick bug report by pressing <kbd class="bg-dark text-white">Ctrl+ALT+R</kbd>
        </div>
      </div>
    </div>
    <div class="card-footer shadow">
      <button
        type="button"
        @click="submitBugReport"
        :disabled="post.busy || !post.details"
        class="btn btn-primary me-2"
      >
        <span v-if="post.busy" class="spinner-border spinner-border-sm me-2"></span>
        Submit Bug Report
      </button>
      <button
        type="button"
        @click="close"
        class="btn btn-light"
      >
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      post: Form.make({
        details: '',
        screenshots: [],
      }),
      dropzone: null,
      submit_times: 0,
    }
  },
  mounted() {
    this.initDropzone();
  },
  beforeDestroy() {
    if (this.dropzone) {
      this.dropzone.destroy();
      this.dropzone = null;
    }
  },
  methods: {
    initDropzone() {
      const self = this;
      this.dropzone = new Dropzone('#kt_dropzonejs_bug_report', {
        headers: this.DROPZONE_HEADERS,
        url: '/', // No direct upload; handled by form submission
        uploadMultiple: true,
        paramName: 'screenshots',
        maxFiles: 3,
        maxFilesize: 2, // MB
        addRemoveLinks: true,
        autoQueue: false,
        acceptedFiles: '.jpeg,.jpg,.png,.gif,.webp',
        init: function () {
          this.on('addedfile', (file) => {
            // Validate file type
            const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
            if (!validTypes.includes(file.type)) {
              this.removeFile(file);
              self.toastError('Invalid file type. Only images are allowed.');
              return;
            }
            
            // Validate file size (2MB)
            if (file.size > 2 * 1024 * 1024) {
              this.removeFile(file);
              self.toastError('File size exceeds 2 MB limit.');
              return;
            }

            // Check if we've reached the max files limit
            if (self.post.screenshots.length >= 3) {
              this.removeFile(file);
              self.toastError('Maximum 3 screenshots allowed.');
              return;
            }

            // Add file to screenshots array
            self.post.screenshots.push(file);
          });

          this.on('removedfile', (file) => {
            // Remove file from screenshots array by finding the matching file
            const index = self.post.screenshots.findIndex(screenshot => screenshot === file);
            if (index > -1) {
              self.post.screenshots.splice(index, 1);
            }
          });

          // this.on('error', (file, errorMessage) => {
          //   if (typeof errorMessage === 'string') {
          //     self.toastError(errorMessage);
          //   } else {
          //     self.toastLaraValidation({ response: { data: errorMessage } });
          //   }
          // });
        }
      });
    },
    async submitBugReport() {
      if (this.submit_times === 0) {
        await this.$root.reportSentry({ details: this.post.details, screenshots: this.post.screenshots });
      }
      this.submit_times++;

      const formData = new FormData();
      formData.append('details', this.post.details);
      formData.append('event_id', window.sentry_event_id);
      // formData.append('event_data', JSON.stringify(window.sentry_event));
      
      // Append all screenshots
      if (this.post.screenshots && this.post.screenshots.length > 0) {
        this.post.screenshots.forEach((screenshot, index) => {
          formData.append(`files`, screenshot);
        });
      }

      this.$axios.post(this.genUrl('bug_report', null, 'post'), formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(({ data }) => {
        alert(`Bug report submitted successfully! Event ID: ${window.sentry_event_id}`);
        this.close();
      })
      .catch((err) => {
        this.toastLaraValidation(err);
        // alert(`Bug report submitted anyway as a fallback! Event ID: ${window.sentry_event_id}`);
        // this.$root.reportSentry({ tags: { report_failure: true } })
        // this.close();
      });
    },
    close() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.dropzone {
  border: 2px dashed #e0e0e0;
  border-radius: 0.475rem;
  padding: 2rem;
  text-align: center;
  background-color: #fafafa;
  transition: border-color 0.3s;
}

.dropzone:hover {
  border-color: #009ef7;
}

.dz-message {
  display: flex;
  align-items: center;
  justify-content: center;
}

kbd {
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
}
</style>

